<template>
	<div v-if="visible" class="badge" :class="classList">{{ content }}</div>
</template>

<script setup>
const THEMES = ['primary', 'orange']

const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	},

	classList: {
		type: Array,
		default: ['primary'],
		validator: (value) => {
			return value.every((className) => ['primary', 'orange'].includes(className))
		}
	},

	content: {
		type: String,
		default: ''
	}
})
</script>

<style lang="scss" scoped>
.badge {
	position: absolute;
	left: -2px;
	font-size: 0.8rem;
	top: 0;
	transform: translateY(-65%);
	color: #fff;
	font-weight: 500;
	padding: 0.18rem 1rem;
	border-radius: 3px 3px 3px 0;
	transition: opacity 0.3s;

	&.primary {
		background-color: #7d8bf7;
	}

	&.orange {
		background-color: #f0907e;
	}

	&.transparent {
		opacity: 0.7;
	}
}
</style>
